import * as React from "react";
import BaseForgotPaswordRoute from "../../features/auth/routes/forgot-password";
import useAppSelector from "../../hooks/useAppSelector";
export default function HomeForgotPasswordRoute() {
    var selectedIssuer = useAppSelector(function (state) { return state.applicant.currentIssuer.home; });
    if (!selectedIssuer) {
        return null;
    }
    return React.createElement(BaseForgotPaswordRoute, { issuer: selectedIssuer });
}
